export default "__VITE_ASSET__BMXZ7SwN__"